import { config } from '../Config/AppConfig';
import { saveLoginExpiredState } from './sessionStorage';

export function handleSignIn(instance, language) {
  const accessTokenRequest = {
    scopes: [`${config.msal.TOKEN_DEFAULT_SCOPE}`],
    extraQueryParameters: {
      mkt: `${language}`,
    },
  };

  instance.acquireTokenPopup(accessTokenRequest).catch((error) => {
    // Acquire token interactive failure
    // eslint-disable-next-line no-console
    console.log(error);
  });
}

export function handleSignOut(instance, language, navigate, location) {
  saveLoginExpiredState(false);
  if (
    location.pathname.includes('/data-analytics-services/hub') ||
    location.pathname.includes('/data-analytics-services/vdl-hub')
  ) {
    navigate('/data-analytics-services/overview');
  } else if (
    location.pathname.includes('/services-analyse-donnees/guichet') ||
    location.pathname.includes('/services-analyse-donnees/guichet-lvd')
  ) {
    navigate('/services-analyse-donnees/apercu');
  }

  instance.logoutPopup({
    extraQueryParameters: {
      mkt: `${language}`,
    },
  });
}
